import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=42377207&scoped=true&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=42377207&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42377207",
  null
  
)

export default component.exports